// Angular
import { Injectable } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
// RxJS
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
// Object-Path
import * as objectPath from 'object-path';
// Services
import { PageConfigService } from './page-config.service';

export interface Breadcrumb {
  title: string;
  url: string | any;
}

export interface BreadcrumbTitle {
  title: string;
  desc?: string;
}

@Injectable()
export class SubheaderService {
  // Public properties
  title$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  breadcrumbs$: BehaviorSubject<Breadcrumb[]> = new BehaviorSubject<Breadcrumb[]>([]);

  // Private properties
  private pageConfig: any;

  constructor(
    private router: Router,
    private pageConfigService: PageConfigService,
    // private activatedRoute: ActivatedRoute
  ) {
    const headerChangesObserver = () => {
      // get updated title current page config
      this.pageConfig = this.pageConfigService.getCurrentPageConfig();

      // get updated subheader title on every route changed
      const headerTranslateKey = objectPath.get(this.pageConfig, 'PageData.Header');
      this.title$.next(headerTranslateKey);

      // get updated breadcrumbs on every route changed
      // const breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      // this.breadcrumbs$.next(breadcrumbs);
    };

    // subscribe to router events
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(headerChangesObserver);
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const title = child.snapshot.data.Breadcrumb;
      if (title !== null && typeof title !== 'undefined') {
        breadcrumbs.push({ url, title });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
